import {
  Form,
  Button,
  Typography,
  CheckboxInput,
  ButtonsWrapper,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';
import { useCurrentMemberContext } from 'src/contexts';

import { useGetGantts } from 'src/hooks/gantts/get-gantts.hook';

import { GanttListWrapper } from './employee-table-filter.styles';

const EmployeeTableFilter = ({
  selected,
  onClose,
  onFinish,
}: {
  selected: string[];
  onClose: () => void;
  onFinish: (values: any) => void;
}) => {
  const { t } = useTranslation('common');
  const { gantts } = useGetGantts();
  const { ganttsAccess = [] } = useCurrentMemberContext();

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Typography weight="bold">{t('labels.gantt')}</Typography>
      <GanttListWrapper>
        {ganttsAccess.map(({ ganttId }: any) => {
          const isChecked = selected.some((_id: string) => _id === ganttId);
          const { name } = gantts.find(({ _id }: any) => _id === ganttId) || {};

          return (
            <Form.Item
              key={ganttId}
              name={['gantts', ganttId]}
              valuePropName="checked"
              initialValue={isChecked}
            >
              <CheckboxInput>{name}</CheckboxInput>
            </Form.Item>
          );
        })}
      </GanttListWrapper>
      <ButtonsWrapper>
        <Button htmlType="submit" type="primary">
          {t('buttons.apply')}
        </Button>
        <Button onClick={onClose}>{t('buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default EmployeeTableFilter;
